import React, { Component } from 'react';
import { withRouter } from 'react-router';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';
import { FormattedMessage, injectIntl } from 'react-intl';
import OnVisible, { setDefaultProps } from 'react-on-visible';
import { Helmet } from 'react-helmet';

import { actions } from '../../shared/store.js';
import ContactUsService from './contact-us.service.js';

import { Title } from '../../components/title/title.component.js';
import QuestionForm from '../../components/question-form/form.component.js';

// mport PageNotFound from '../../components/not-found/page-not-found.js';

import './contact-us.page.scss';

class ContactUsPage extends Component {
	static prefetchData = async language => ContactUsService.getData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		const { contactUs, setLoading } = this.props;
		if (!contactUs) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language } = this.props;
		if (prevProps.language.value !== language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		const { setLoading, setContactUs, language } = this.props;
		setLoading(true);

		ContactUsPage.prefetchData(language.value)
			.then((data) => {
				setContactUs(data);
				setLoading(false);
			})
			.catch(() => {
				const { history } = this.props;
				setLoading(false);
				history.push('/404');
				this.setState({
					hasError: true,
				});
			});
	}

	render() {
		const { hasError } = this.state;
		const {
			intl,
			contactUs,
			mainData,
		} = this.props;

		if (hasError || !contactUs || !mainData) {
			return null;
		}

		setDefaultProps({
			visibleClassName: 'visible',
			percent: 20,
		});

		const {
			title,
			contactsImage,
		} = contactUs;

		return (
			<div id="contact-us-page">
				<Helmet>
					<title>
						{intl.formatMessage({
							id: 'navigation.contact-us',
						})}
					</title>
					<meta
						name="description"
						content={title}
					/>
					<link
						rel="canonical"
						href={`${
							process.env.REACT_APP_URL
						}/contact-us`}
					/>

					<meta
						property="og:url"
						content={`${
							process.env.REACT_APP_URL
						}/contact-us`}
					/>

				</Helmet>

				<section className="initial-section">
					<div className="container container-fluid">
						<div className="row section-wrapper">
							<OnVisible className="col-xs-12 col-md-6 left-section">
								<div className="col-md-12 title">
									<div className="title-wrapper">
										<Title theme="dark" label={title} />
									</div>
								</div>

								<div className="col-md-12 email-wrapper">
									<div className="email-title">
										<FormattedMessage id="contactUs.email_title" />
									</div>
									<div>
										<a href={`mailto:${mainData.email}`} className="right">
											{mainData.email}
										</a>
									</div>
								</div>

								<div className="col-md-12 form">
									<QuestionForm />
								</div>
							</OnVisible>
							<div className="col-xs-12 col-md-4 col-md-offset-2 right-section">
								<OnVisible className="image">
									{contactsImage.path && (
										<img
											src={`${process.env.REACT_APP_API_ENDPOINT + contactsImage.path}`}
											alt="Contact-Us"
										/>
									)}
								</OnVisible>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

const mapToProps = ({
	language, contactUs, mainData, isLoading,
}) => ({
	language,
	contactUs,
	mainData,
	isLoading,
});

export default withRouter(
	injectIntl(
		connect(
			mapToProps,
			actions,
		)(ContactUsPage),
	),
);

export { ContactUsPage };
